import VueI18n from 'vue-i18n';
import Vue from 'vue';

Vue.use(VueI18n);
const i18n = new VueI18n({
  messages, // eslint-disable-line
  locale: navigator.language.split('-')[0],
});

export default i18n;
